import { Tag, TagProps } from 'bold-ui'
import { gray, red, yellow } from 'bold-ui/lib/styles/colors'
import { EstratificacaoRisco } from 'graphql/types.generated'

interface RastreamentosEstratificacaoTagProps {
  estratificacao: EstratificacaoRisco
}

const ESTRATIFICACAO_MAP: Record<EstratificacaoRisco, { label: string; tagProps: TagProps }> = {
  [EstratificacaoRisco.BAIXO]: {
    label: 'Baixo',
    tagProps: { style: { backgroundColor: yellow.c80, color: gray.c10 } },
  },
  [EstratificacaoRisco.MODERADO]: { label: 'Moderado', tagProps: { type: 'alert' } },
  [EstratificacaoRisco.ALTO]: { label: 'Alto', tagProps: { type: 'danger' } },
  [EstratificacaoRisco.MUITO_ALTO]: {
    label: 'Muito Alto',
    tagProps: { style: { backgroundColor: red.c20, color: red.c100 } },
  },
}

export function RastreamentosEstratificacaoTag(props: Readonly<RastreamentosEstratificacaoTagProps>) {
  const { estratificacao } = props
  const { label, tagProps } = ESTRATIFICACAO_MAP[estratificacao]

  return <Tag {...tagProps}>{label}</Tag>
}
